import React from "react";
import { motion } from "framer-motion";

interface LoadingStateProps {
  isDarkMode: boolean;
}

export const LoadingState: React.FC<LoadingStateProps> = ({ isDarkMode }) => {
  return (
    <div className="flex items-center justify-center h-screen">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
        className={`w-16 h-16 border-4 border-t-phoenix-500 rounded-full ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      />
    </div>
  );
};
